var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMap = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a202c",
    stroke: "#1a202c",
    strokeWidth: 0.75,
    d: "M16.89.328l8.044 2.475c.252.078.438.334.435.599v17.95c0 .385-.434.705-.803.59l-7.86-2.417-7.86 2.417c-.118.037-.249.037-.367 0L.435 19.467c-.25-.078-.435-.329-.435-.59V.927c-.005-.39.432-.715.803-.6l7.86 2.418 7.86-2.417c.131-.044.281-.015.367 0h0zm.435 1.44v16.645l6.806 2.088V3.856l-6.806-2.088zm-1.237 0L9.28 3.856v16.645l6.807-2.088V1.768zm-14.85 0v16.645L8.044 20.5V3.856L1.238 1.768z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map.f45f7f2d.svg";
export { ForwardRef as ReactComponent };